import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationPopupComponent } from 'src/app/shared/component/confirmation-popup/confirmation-popup.component';
import { Context } from 'src/app/shared/models/context';
import { CourseList, CourseTest, EmployeeAnswer, EmployeeReport } from 'src/app/shared/models/course';
import { CourseService } from 'src/app/shared/services/course.service';
import { DataService } from 'src/app/shared/services/data.service';
import { ConfirmationsPopupComponent } from '../../confirmation-popup/confirmations-popup.component';
import { EmployeeReportViewComponent } from '../../employee-report-view/employee-report-view.component';


@Component({
  selector: 'app-exam-attend',
  templateUrl: './exam-attend.component.html',
  styleUrls: ['./exam-attend.component.scss']
})
export class ExamAttendComponent implements OnInit {
  @Input() courseTest: CourseTest;
  @Input() course: CourseList;
  @Input() context: Context;
  public courseTests: CourseTest[] = [];
  public questionDataMap: Map<string, any[]> = new Map();
  public flatQuestions: any[] = [];
  public currentIndex = 0;
  public selectedAnswers: { [key: string]: any } = {};
  public answeredQuestionsCount = 0;
  public timer: string = '00:00:00';
  public elapsedTime: number = 0; // Start from 0 seconds
  public interval: any;
  public isSubmitted: boolean = false;
  public employeeReport: EmployeeReport;
  public isLoading: boolean = true;
  public courseTestEmployeeId: number;
  public courselist: CourseList[] = [];

  constructor(
    private courseService: CourseService,
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private dataService: DataService,

  ) { }

  ngOnInit(): void {
    if (this.course?.courseId) {
      this.getCourseTests(this.course?.courseId);
    }
    this.startTimer();
  }

  private startTimer(): void {
    this.interval = setInterval(() => {
      this.elapsedTime++;
      const hours = Math.floor(this.elapsedTime / 3600).toString().padStart(2, '0');
      const minutes = Math.floor((this.elapsedTime % 3600) / 60).toString().padStart(2, '0');
      const seconds = (this.elapsedTime % 60).toString().padStart(2, '0');
      this.timer = `${hours}:${minutes}:${seconds}`;
    }, 1000);
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }

  get isLastQuestion(): boolean {
    return this.currentIndex === this.flatQuestions.length - 1;
  }

  public getCourseTests(courseId: number) {
    this.courseService.getCourseTests(courseId, "RELEASED").subscribe({
      next: (courseTests: CourseTest[]) => {
        this.courseTests = courseTests.filter(test => test.approvalStatus === "RELEASED");
        let releasedTestId = this.course.courseTestId;
        this.courseTestQuestions(releasedTestId);
        this.createCourseTestForEmployee(releasedTestId);
      },
      error: (error: HttpErrorResponse) => {
      }
    });
  }

  public courseTestQuestions(courseId: number) {
    this.courseService.getCourseTestQuestions(this.course.courseTestId).subscribe({
      next: (response) => {
        this.questionDataMap = response;
        this.questions();
      },
      error: (error: HttpErrorResponse) => {
      }
    });
  }

  private questions() {
    this.flatQuestions = [];
    Object.entries(this.questionDataMap).forEach(([category, questions]: [string, any[]]) => {
      questions.forEach((q: any) => {
        this.flatQuestions.push({ ...q, category });
      });
    });
  }

  public nextQuestion(): void {
    const currentQuestion = this.flatQuestions[this.currentIndex];
    if (!this.selectedAnswers[this.currentIndex]) {
      this.toastr.warning('Please select an answer before proceeding.', 'Warning');
      return;
    }
    const selectedChoiceId = this.selectedAnswers[this.currentIndex];
    const selectedChoice = currentQuestion.questionChoice.find(
      (choice) => choice.id === selectedChoiceId
    );
    if (!selectedChoice) {
      this.toastr.warning('Invalid selection. Please select a valid answer.', 'Warning');
      return;
    }
    const employeeAnswer: EmployeeAnswer = {
      courseTestEmployeeId: this.courseTestEmployeeId,
      courseQuestionChoiceId: selectedChoiceId,
      courseQuestionChoiceName: selectedChoice.choice,
      date: new Date().toISOString().split('T')[0],
    };
    this.courseService.createCourseTestEmployeeAnswer(employeeAnswer).subscribe({
     next: () => {
        this.toastr.success('Answer saved!', 'Success');
        this.answeredQuestionsCount++;
        if (this.currentIndex < this.flatQuestions.length - 1) {
          this.currentIndex++;
        }
      },
      error: () => {
      },
    }); 
  }

  public submitExam(): void {
    const unansweredQuestions = this.flatQuestions.filter((_, index) => !this.selectedAnswers[index]);
  
    if (unansweredQuestions.length > 0) {
      this.toastr.warning('Please answer all the questions before submitting the exam.', 'Warning');
      return;
    }
    const currentQuestion = this.flatQuestions[this.currentIndex];
    if (!this.selectedAnswers[this.currentIndex]) {
      this.toastr.warning('Please select an answer before proceeding.', 'Warning');
      return;
    }
    const selectedChoiceId = this.selectedAnswers[this.currentIndex];
    const selectedChoice = currentQuestion.questionChoice.find(
      (choice) => choice.id === selectedChoiceId
    );
    if (!selectedChoice) {
      this.toastr.warning('Invalid selection. Please select a valid answer.', 'Warning');
      return;
    }
    const employeeAnswer: EmployeeAnswer = {
      courseTestEmployeeId: this.courseTestEmployeeId,
      courseQuestionChoiceId: selectedChoiceId,
      courseQuestionChoiceName: selectedChoice.choice,
      date: new Date().toISOString().split('T')[0],
    };
    this.courseService.createCourseTestEmployeeAnswer(employeeAnswer).subscribe({
      next: () => {
        //  this.toastr.success('Answer saved!', 'Success');
       },
       error: () => {
       },
     }); 
  
    this.updateExamStatusAndClose(this.courseTestEmployeeId, "COMPLETED");
  
    this.courseService.getEmployeeTestReports(this.courseTestEmployeeId).subscribe({
      next: (report: EmployeeReport) => {
        this.employeeReport = report;
        this.isSubmitted = true;
        this.dataService.triggerRefreshCourseList();
  
        const modalRef = this.modalService.open(ConfirmationsPopupComponent, {
          size: 'lg',
          backdrop: 'static'
        });
  
        modalRef.componentInstance.title = 'Exam Submitted';
        modalRef.componentInstance.message = 'Your exam has been submitted!';
        modalRef.componentInstance.isSuccess = true;
  
        modalRef.result.then((result) => {
          if (result === 'report') {
            this.activeModal.close();
            this.viewReport(report);
          }
        }).catch(() => {
          this.activeModal.close();
        });
  
        this.toastr.success('Exam submitted successfully!', 'Success');
      },
      error: () => {
        this.toastr.error('Failed to fetch your report.');
      }
    });
  }
  


  private updateExamStatusAndClose(courseTestId: number, status: string) {
    this.courseService.updateCourseTestEmployee(this.courseTestEmployeeId, status).subscribe({
      next: () => {
        if (status === 'COMPLETED') {
          this.isSubmitted = true;
        }
        this.activeModal.close();
      },
      error: (error) => {
      }
    });
  }

  public confirmCloseModal() {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.course = "Confirm Exam Completion";
    modalRef.componentInstance.prefixMessage = "Are you sure you want to submit the exam?";
    modalRef.componentInstance.message = "This action will mark the exam as INCOMPLETE.";
    modalRef.componentInstance.label = 'Submit Exam';
    modalRef.result.then((isConfirmed: boolean) => {
      if (isConfirmed) {
        this.updateExamStatusAndClose(this.courseTests[0].id, "INCOMPLETE");
      }
    }).catch(() => {
      this.activeModal.close();
    });
  }

  private createCourseTestForEmployee(courseTestId: number) {
    this.courseService.createCourseTestEmployee(courseTestId).subscribe({
      next: (response) => {
        this.courseTestEmployeeId = response.payload;
        this.toastr.success(response.text);
      },
      error: (error) => {
      }
    });
  }

  public viewreports() {
    this.courseService.getEmployeeTestReports(this.courseTestEmployeeId).subscribe({
      next: (report: EmployeeReport) => {
        this.employeeReport = report;
        this.viewReport(report);
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  public viewReport(report: EmployeeReport) {
    const modalRef = this.modalService.open(EmployeeReportViewComponent, { size: 'xl', backdrop: 'static' });
    modalRef.componentInstance.employeeReport = report;
  }

  get answeredQuestionsCounts(): number {
    return Object.keys(this.selectedAnswers).length;
  }
  
}



